import React from 'react'
import Sidebar from '../components/MainSidebar'

const PageSideRoute = () => {
  return (
    <div>
        <Sidebar/>
    </div>
  )
}

export default PageSideRoute

